// Reports Library domain — pre-canned firm reports with PDF/CSV export.
import { API } from './_client';

export const reportsLibrary = {
  library: () => API.get('/reports/library').then((r) => r.data),
  run: (payload) => API.post('/reports/library/run', payload).then((r) => r.data),
  exportCsv: (payload) => API.post('/reports/library/export.csv', payload, { responseType: 'blob' }).then((r) => r.data),
  exportPdf: (payload) => API.post('/reports/library/export.pdf', payload, { responseType: 'blob' }).then((r) => r.data),
};
